export const DIMENSIONS = {
  TABLET_WIDTH: 316,
  TABLET_HEIGHT: 497,
  DESKTOP_WIDTH: 417,
  DESKTOP_HEIGHT: 561,
};
